import React, { useState, useEffect } from "react";

// Icons
import {
  BiEditAlt,
  BiTrash,
  BiChevronsRight,
  BiChevronsLeft,
} from "react-icons/bi";


// Props Values
/* 
  data: [],  
  pageSize: 0,
  columns: ['Id', 'Name'],
  fields: ['id', 'name'],
  onEdit : function
  onDelete: function
*/

const PaginatedTable = (props) => {
  const [initPageIndex, setInitPageIndex] = useState(0);
  const [endPageIndex, setEndPageIndex] = useState(props.pageSize);
  const [paginateIndex, setPaginateIndex] = useState(1);
  const [registers, setRegisters] = useState(props.data);

  const onEdit = (item) => props.onEdit(item);
  const onDelete = (item) => props.onDelete(item);

  const amountPages = () => {
    var division = registers.length / props.pageSize;
    var remainder = division % 1;
    var quotient = division - remainder;
    if (remainder > 0) quotient += 1;
    return quotient;
  };

  const onPaginate = (index) => {
    if (index > 0 && index <= amountPages()) {
      setPaginateIndex(index);
      setInitPageIndex(index * props.pageSize - props.pageSize); // 3*10-10 = 20
      setEndPageIndex(index * props.pageSize); // 3*10 = 30
    }
  };

  const buttons = (item) => {
    return (
      <>
        <div className='row'>
          <div className='col-6'>
            <BiEditAlt className='icon-button' onClick={() => onEdit(item)} />
          </div>
          <div className='col-6'>
            <BiTrash className='icon-button' onClick={() => onDelete(item)} />
          </div>
        </div>
      </>
    );
  };

  useEffect(() => {
    (async () => {
      
      setRegisters(props.data)
    })();

  }, [props]);

  return (
    <>

      <div className='table-responsive text-nowrap'>
        <table className='table' id='paginated-table'>
          <thead>
            <tr>
              {props.columns &&
                props.columns.map((column, index) => (
                  <th key={index}>{column}</th>
                ))}
              <th>Ações</th>
            </tr>
          </thead>
          <tbody className='table-border-bottom-0'>
            {
              registers.map((item, index) =>
                index >= initPageIndex && index < endPageIndex ? (
                  <tr key={index}>
                    {props.fields.map((fields, fieldsIndex) => (
                      <td key={fieldsIndex}>{item[fields]}</td>
                    ))}

                    <td className='action-table-col'>
                      {item.hasOwnProperty("infoCar") ? (
                        item["infoCar"] === "N" ? (
                          <>{buttons(item)}</>
                        ) : (
                          ""
                        )
                      ) : (
                        <>{buttons(item)}</>
                      )}
                    </td>
                  </tr>
                ) : (
                  ""
                )
              )}
          </tbody>
        </table>

        <nav aria-label='Page navigation'>
          <ul className='pagination'>
            <li className='page-item'>
              <button
                className='page-link'
                onClick={() => onPaginate(paginateIndex - 1)}>
                <BiChevronsLeft />
              </button>
            </li>

            {registers &&
              Array.from({ length: amountPages() }, (_, i) => i + 1).map(
                (item, itemIndex) => (
                  <li
                    key={itemIndex}
                    className={`page-item ${paginateIndex === item ? "active" : ""
                      }`}>
                    <button
                      className='page-link'
                      onClick={() => onPaginate(item)}>
                      {item}
                    </button>
                  </li>
                )
              )}

            <li className='page-item '>
              <button
                className='page-link'
                onClick={() => onPaginate(paginateIndex + 1)}>
                <BiChevronsRight />
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};
export default PaginatedTable;
